import env from "../env";

export const BACKEND_URI = env.API_URL;